import type { PromiseToPayListItemApi, UpdatePromiseToPayRequest } from '@/hooks/usePromisesToPayData';
import { generateMockPromises } from '@/lib/mock-data/collections-mock-data';

/**
 * Demo-mode fabricated response for updating a promise to pay.
 * Used as the demoFn for useUpdatePromiseToPay.
 */
export function updatePromiseToPayDemoResponse(request: UpdatePromiseToPayRequest): PromiseToPayListItemApi {
  const mockPromises = generateMockPromises();
  const existing = mockPromises.find((p) => p.id === request.promiseId);
  return {
    promiseId: request.promiseId,
    customerId: existing ? parseInt(existing.customerId) : 0,
    companyName: null,
    customerName: existing?.customerName ?? 'Mock Customer',
    customerAccountNumber: existing?.customerAccountNumber ?? null,
    promiseDate: request.promiseDate,
    promisedAmount: request.promisedAmount,
    currencyCode: existing?.currencyCode ?? null,
    status: existing?.status ?? 'Active',
    confirmationMethod: existing?.confirmationMethod ?? 'Phone',
    createdBy: existing?.createdBy ?? 'Demo User',
    assignedUserId: request.assignedUserId ?? existing?.assignedUserId ?? 0,
    assignedUserName: existing?.assignedUserName ?? null,
    createdAt: existing?.createdAt.toISOString() ?? new Date().toISOString(),
    notes: request.notes ?? null,
    daysOverdue: existing?.daysOverdue ?? null,
    isAtRisk: existing?.isAtRisk ?? false,
    brokenPromisesCount: existing?.brokenPromisesCount ?? 0,
    contactEmail: existing?.customerEmail ?? null,
    contactPhone: existing?.customerPhone ?? null,
    contactName: request.contactId ? 'New Contact' : (existing?.contactName ?? null),
    contactId: request.contactId ?? (existing?.contactId ? parseInt(existing.contactId) : null),
    caseId: existing?.caseId ? parseInt(existing.caseId) : null,
    caseNumber: existing?.caseNumber ?? null,
    invoiceCount: existing?.invoiceCount ?? 0,
    lastAction: null,
    linkedInvoices: [],
  };
}
